export default [
  {
    name: 'categoryManagement',
    path: '/electronicRecordsManagement/categoryManagement',
    component: () => import('@/views/electronicRecordsManagement/categoryManagement/index.vue'),
    meta: {
      title: '类目管理'
    }
  },
  {
    name: 'directoryManagement',
    path: '/electronicRecordsManagement/directoryManagement',
    component: () => import('@/views/electronicRecordsManagement/directoryManagement/index.vue'),
    meta: {
      title: '目录管理'
    }
  },
  {
    name: 'fileManagement',
    path: '/electronicRecordsManagement/fileManagement',
    component: () => import('@/views/electronicRecordsManagement/fileManagement/index.vue'),
    meta: {
      title: '档案管理'
    }
  },
  {
    name: 'fileRecords',
    path: '/electronicRecordsManagement/fileRecords',
    component: () => import('@/views/electronicRecordsManagement/fileRecords/index.vue'),
    meta: {
      title: '档案记录'
    }
  },
  {
    name: 'downloadRecord',
    path: '/electronicRecordsManagement/downloadRecord',
    component: () => import('@/views/electronicRecordsManagement/downloadRecord/index.vue'),
    meta: {
      title: '下载记录'
    }
  }
]
